// @flow
import React, { useState } from "react";
import Samples from "./Samples";
import ProductPerCompoundFailureSearch from "./product_per_compound_failures/ProductPerCompoundFailureSearch";
import ProductPerCompoundFailureReport from "./product_per_compound_failures/ProductPerCompoundFailureReport";

export default function ProductPerCompoundFailureSummary({
  company_id,
  clientView = true,
  placeholder_image,
}) {
  const [data, setData] = useState(null);
  const [searchParams, setSearchParams] = useState(null);

  const handleQuery = ({ data, searchParams }) => {
    setSearchParams(searchParams);
    setData(data);
  };

  return (
    <div>
      <ProductPerCompoundFailureSearch company_id={company_id} onLoad={handleQuery} />
      {data && <ProductPerCompoundFailureReport data={data} searchParams={searchParams} />}
      {placeholder_image &&
        !data && (
          <div
            style={{
              margin: "0 auto",
              display: "table",
              marginTop: "20px",
            }}
          >
            <img src={placeholder_image} style={{ maxWidth: "100vw" }} />
          </div>
        )}
    </div>
  );
}
